module.exports = __webpack_public_path__ + "assets/img/play-991711b0.png";